import { useEffect, useState } from "react";
import { getClientShortlistDetail, listClientShortlists } from "../services/clientShortlistService";

/**
 * PKT-0841 · does this client's shortlist have any places on it?
 * true / false once known, null while loading or when the read failed —
 * callers then show the neutral "Shortlist" label rather than guess.
 *
 * READ-ONLY on purpose: never getOrCreate here. Opening the modal already
 * creates an empty list row, so "a list row exists" would flip the label to
 * "Edit List" for a list with nothing on it. Items are what count.
 */
export function useShortlistHasItems(clientId: string | null | undefined, refreshKey = 0): boolean | null {
  const [hasItems, setHasItems] = useState<boolean | null>(null);
  useEffect(() => {
    setHasItems(null);
    if (!clientId) return;
    let cancelled = false;
    (async () => {
      try {
        const lists = await listClientShortlists(clientId);
        let found = false;
        for (const list of lists) {
          const detail = await getClientShortlistDetail(list.id);
          if ((detail.items || []).some((item) => item.status !== "removed")) {
            found = true;
            break;
          }
        }
        if (!cancelled) setHasItems(found);
      } catch {
        if (!cancelled) setHasItems(null);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [clientId, refreshKey]);
  return hasItems;
}
